module.exports = __webpack_public_path__ + "img/usa.4d5c1069.svg";